import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col
} from 'reactstrap';
import ProgressBox from '@src/components/ProgressBox/ProgressBox';
import EOITypes from '@components/EvidenceOfInsurance/Types/Types';

class TypeModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      type: props.entity.type,
      focused: false,
      error: false
    };
  }

  submitHandler = e => {
    e.preventDefault();

    this.props.loader(true);

    this.props.saveEntity(
      {
        type: this.state.type
      },
      () => {
        this.props.loader(false);
        this.props.toggle();
      }
    );

    return false;
  };

  render = () => {
    return (
      <Modal
        isOpen={this.props.isActive}
        toggle={this.props.toggle}
        className={this.props.className}
      >
        <form
          ref={c => {
            this.form = c;
          }}
          onSubmit={this.submitHandler.bind(this)}
        >
          <ModalHeader toggle={this.props.toggle}>
            {this.props.header}
          </ModalHeader>
          <div className={'position-relative'}>
            {this.props.loading && <ProgressBox text={'Submiting ...'} />}
            <ModalBody className={'p-4'}>
              <Row>
                <Col xs={12}>
                  <div className={'form-group'}>
                    <label className={'font-weight-bold'}>EOI Type</label>
                    <select
                      className={'form-control'}
                      value={this.state.type}
                      onChange={event =>
                        this.setState({
                          type: event.target.value
                        })
                      }
                    >
                      {EOITypes.map(item => {
                        return (
                          <option key={item.key} value={item.key}>
                            {item.label}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter className={'py-4'}>
              <Button color="primary" className={'btn px-3'} type={'submit'}>
                {this.props.edit !== undefined ? 'Save' : 'Create'}
              </Button>
            </ModalFooter>
          </div>
        </form>
      </Modal>
    );
  };
}
export default TypeModal;
